export const getListId = (data) => data.map((item) => item.organizationId)

export const convertDataTable = (data) => {
  const ids = getListId(data)
  const objData = {}

  ids.forEach((id, index) => {
    const dataRow = data.find((item) => item.organizationId === id)
    const datePublicCredit =
      new Date(dataRow?.creditRiskPublicDate).getMonth() + 1
    const datePublicPerformance =
      new Date(dataRow?.performancePublicDate).getMonth() + 1

    objData[id] = {
      ...dataRow,
      organizationName: {
        name: dataRow?.organizationName,
        allowRedirectLink: dataRow?.allowRedirectLink,
      },
      creditRiskScore: {
        creditRiskScore: dataRow?.creditRiskScore,
        publicDate: dataRow?.creditRiskPublicDate,
        isLastQuarter: datePublicCredit === 12,
        colorCode: dataRow.colorCode,
      },
      performanceScore: {
        performanceScore: dataRow?.performanceScore,
        publicDate: dataRow?.performancePublicDate,
        isLastQuarter: datePublicPerformance === 12,
        colorCode: dataRow.colorCode,
      },
      stt: index + 1,
    }
  })
  return objData
}
export const convertDataTableRaw = (data) => {
  return data.map((obj) => {
    return {
      performanceScore: 0,
      creditRiskScore: 0,
      ...obj,
    }
  })
}
